/**
 *
 * @author Russell Lilljedahl
 * @prettier
 *
 * @since 23.6
 *
 * */
import React from 'react'
import LGYMessageImage from './LGYMessageImage'
/**
 * Image link to the CSM chatbot and anonymous submit help button
 *
 * @property {string} linkExternal - Hyperlink to the logged out external submit help function
 * @property {string} linkAnonymous - Hyperlink to the anonymous submit help function
 * */

const SubmitHelpAnonymously = props => (
  <div>
    Want to contact us? No problem
    <p>
      We notice you are not logged in. If you have a current working ID.me account where you can successfully log on,
      please click "I have an ID.me account" if you want to logon and have the full Help Desk ticket experience where
      you can submit tickets as yourself and see current and past tickets. If not, click "Submit help ticket
      anonymously" to enter a help ticket as a guest user.
    </p>
    <a
      className='usa-button submit-help-ticket-link'
      href={props.linkExternal}
      target='_blank'
      rel='noopener noreferrer'
    >
      I have an ID.me account
    </a>
    <a
      className='usa-button submit-help-ticket-link'
      href={props.linkAnonymous}
      target='_blank'
      rel='noopener noreferrer'
    >
      Submit help ticket anonymously
    </a>
    <LGYMessageImage link='https://yourit.va.gov/csm'></LGYMessageImage>
  </div>
)

export default SubmitHelpAnonymously
